import React from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';
import {
  Container, Row, Col, Button,
} from 'react-bootstrap';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import BaseModal from '../../form/BaseModal';
import EbillService from '../../../service/EbillService';
import Confirm from '../../confirm/Confirm';

class EbillCustomerDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enrollmentUpdateMessage: null,
      unenrollConfirmationOpen: false,
      isLoading: false,
    };
  }

  format(item) {
    return {
      actiontype: item.actionType,
      timeStamp: new Date(item.timeStamp).toLocaleString(),
    };
  }

  handleUnenrollConfirmationOpen = () => {
    this.setState({ unenrollConfirmationOpen: true, });
  };

  handleUnenrollConfirmationClose = () => {
    this.setState({ unenrollConfirmationOpen: false, });
  };

  unenrollCustomer(ebillCustomer) {
    this.setState({
      enrollmentUpdateMessage: `Unenrolling enrollment with id: ${ebillCustomer.id}`,
      isLoading: true,
    });
    let nextMessage = '';
    EbillService.unenrollCustomer(ebillCustomer.ebillingHistoryId)
      .then(() => {
        nextMessage = `Unenrolled enrollment with id: ${ebillCustomer.id}`;
      })
      .catch((err) => {
        nextMessage = `Failed to unenroll ebilling enrollment with id: ${ebillCustomer.id}`;

        console.log(err);
      })
      .finally(() => {
        this.setState({
          enrollmentUpdateMessage: nextMessage,
          unenrollConfirmationOpen: false,
          isLoading: false,
        });
      });
  }

  render() {
    const { ebillCustomer, } = this.props;
    const models = ebillCustomer.historyItems.map(item => this.format(item));
    const model = Grid.toModelFromList(models, {
      headerFormatter: value => lodash.startCase(value.header),
    });

    const renderUnenrollButton = () => {
      const {
        unenrollConfirmationOpen,
        isLoading,
      } = this.state;
      if (!ebillCustomer || ebillCustomer.currentStatus !== 'ENROLLED') {
        return null;
      }

      return (
        <>
          <Button variant="primary" onClick={() => this.handleUnenrollConfirmationOpen()}>
            Unenroll
          </Button>
          <Confirm
            isLoading={isLoading}
            title="Unenroll eBilling Enrollment"
            content={`Are you sure you want to unenroll enrollment with id: ${ebillCustomer.id}?`}
            open={unenrollConfirmationOpen}
            onClose={this.handleUnenrollConfirmationClose}
            onYes={() => this.unenrollCustomer(ebillCustomer)}
            onNo={this.handleUnenrollConfirmationClose}
          />
        </>
      );
    };

    const { enrollmentUpdateMessage, } = this.state;
    return (
      <div>
        <Container>
          <Row>
            <Col>
              <BaseModal title="E-bill History" buttonLbl="Details">
                <FieldSet title="Summary">
                  <Grid rows={model.format(models)} headers={model.headers} />
                </FieldSet>
              </BaseModal>
            </Col>
            <Col>
              {renderUnenrollButton()}
            </Col>
          </Row>
          <Row>
            {enrollmentUpdateMessage && <p style={{ marginTop: '10px', }}>{enrollmentUpdateMessage}</p>}
          </Row>
        </Container>
      </div>
    );
  }
}

EbillCustomerDetails.propTypes = {
  ebillCustomer: PropTypes.object.isRequired,
};

export default EbillCustomerDetails;
